import { IconProps } from "@assets/svg/types";
import { useTheme } from "@hooks";

export const SuccessIcon = ({ style }: IconProps) => {
  const { theme } = useTheme();

  return (
    <svg
      width="90"
      height="90"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <rect
        x="0.25"
        width="89.5"
        height="89.5"
        rx="44.75"
        fill={theme.withdrawal.success.background}
      />
      <path
        d="M41.3442 55.1734L59.9555 36.5621L57.1863 33.793L41.3442 49.6351L33.6808 41.9716L30.9116 44.7408L41.3442 55.1734Z"
        fill={theme.withdrawal.success.default}
      />
    </svg>
  );
};
